import { Link } from "react-router-dom";

export default function ApiDocs() {
  return (
    <div className="min-h-screen bg-gray-50">
      <div className="bg-gradient-to-r from-gray-800 to-gray-900 text-white">
        <div className="container mx-auto px-4 py-16 text-center">
          <h1 className="text-4xl font-bold mb-4">🔧 API Documentation</h1>
          <p className="text-gray-300 text-lg max-w-2xl mx-auto">
            ExamLock currently operates as a web application built on Firebase Cloud Functions.
            A public API is planned for future releases.
          </p>
        </div>
      </div>

      <div className="container mx-auto px-4 py-16 max-w-3xl">
        <div className="bg-white rounded-2xl shadow-lg p-8 mb-8">
          <h2 className="text-2xl font-bold text-gray-900 mb-4">Current Architecture</h2>
          <p className="text-gray-600 mb-4">
            ExamLock is powered by Firebase Cloud Functions (Google Cloud Run). All critical actions —
            exam submission, grading, violation logging, and student management — are enforced server-side.
          </p>
          <ul className="space-y-3 text-gray-700 text-sm">
            <li className="flex items-start"><span className="text-blue-500 mr-2 mt-0.5">•</span>Authentication: Firebase Auth (email/password, Google OAuth)</li>
            <li className="flex items-start"><span className="text-blue-500 mr-2 mt-0.5">•</span>Data storage: Firestore (Google Cloud)</li>
            <li className="flex items-start"><span className="text-blue-500 mr-2 mt-0.5">•</span>Server functions: Firebase Cloud Functions v2 (onCall, scheduled)</li>
            <li className="flex items-start"><span className="text-blue-500 mr-2 mt-0.5">•</span>AI generation: Routed through server-side Cloud Functions (no client API key exposure)</li>
          </ul>
        </div>

        <div className="bg-blue-50 rounded-2xl p-8 mb-8 border border-blue-100">
          <h2 className="text-2xl font-bold text-gray-900 mb-4">🔌 Public API — Coming Soon</h2>
          <p className="text-gray-600 mb-4">
            A documented public API for school integrations (SIS, LMS, reporting systems) is on our
            product roadmap. If your school requires an API integration as part of procurement, please
            contact us to discuss requirements.
          </p>
          <p className="text-gray-500 text-sm">
            Features and timelines may change during beta.
          </p>
        </div>

        <div className="text-center">
          <Link
            to="/contact"
            className="inline-block bg-blue-600 text-white px-8 py-3 rounded-lg font-bold hover:bg-blue-700 transition duration-200"
          >
            Contact Us About Integrations
          </Link>
        </div>
      </div>
    </div>
  );
}
